<section modalContainer invisibleWhitespace>
    <app-modal-header header>
        @if (schedule(); as item) {
            <div class="flex w-full gap-3 items-center *:font-medium">
                <h4>회기 일지 작성</h4>
                <div class="flex gap-2 items-center">
                    @if (item.log) {
                        <app-badge color="gray" variant="light"
                            >작성 완료</app-badge
                        >
                    } @else {
                        <app-badge color="orange" variant="light"
                            >작성 대기</app-badge
                        >
                    }
                    <p class="text-gray-800 text-sm">
                        {{ item.startAt | date: "y.MM.dd (E)" }}
                    </p>
                </div>
                <div class="px-1.5 py-0.5 category-badge text-gray-800 text-xs">
                    {{ item.currentMonthScheduleIndex + 1 }}/{{
                        item.currentMonthScheduleCount
                    }}
                </div>
            </div>
        }
    </app-modal-header>
    <div class="p-4 flex flex-col gap-4 min-w-[35rem]">
        <div class="flex flex-col gap-2">
            <div class="flex w-full justify-between items-center">
                <app-label>회기 기록</app-label>
                <app-button
                    size="sm"
                    icon="bitcoin-icons:magic-wand-filled"
                    [loading]="aiLoading()"
                    (click)="aiEnhance()"
                    >AI 보정</app-button
                >
            </div>
            <app-textarea
                height="300"
                [field]="form.content"
                placeholder="회기 기록"
                [hint]="[
                    '회기 기록 작성 후 AI 보정 버튼을 눌러 기능을 사용해보세요!',
                ]"
            />

            <app-textarea
                label="상담 내용"
                height="150"
                [field]="$any(form.counselingContent)"
                placeholder="상담 내용"
            />

            <app-textarea
                label="특이 사항"
                height="150"
                [field]="$any(form.specialContent)"
                placeholder="특이 사항"
            />

            <div class="flex flex-col gap-2">
                <app-label>파일 첨부</app-label>
                <app-file-uploader
                    [field]="$any(form.files)"
                    [uploadHandler]="upload"
                    [deleteHandler]="delete"
                />
            </div>
        </div>
    </div>
    @if (editRole()) {
        <div footer class="flex gap-3 items-center p-4">
            <app-button
                variant="outline"
                color="gray"
                [expand]="true"
                (click)="close()"
                >취소</app-button
            >
            <app-button
                [expand]="true"
                [disabled]="form().invalid() || aiLoading()"
                (click)="submit()"
                >저장</app-button
            >
        </div>
    }
</section>
